import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'

const SaveButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  padding: `10px ${theme.spacing(6)}px`,
  color: theme.palette.common.white,
  backgroundColor: theme.palette.grey[800],
  border: `1px solid ${theme.palette.grey[800]}`,
  fontWeight: 500,
  position: 'relative',
  textTransform: 'capitalize',
  '& svg': {
    width: 0,
    height: 0,
    opacity: 0,
    transition: 'width 0.3s ease, height 0.3s ease, opacity 0.3s ease'
  },
  '&:hover': {
    border: `1px solid ${theme.palette.success.main}`,
    backgroundColor: theme.palette.success.main,
    '& svg': {
      width: 24,
      height: 24,
      opacity: 1
    }
  },
  [theme.breakpoints.up('md')]: {
    marginRight: 14
  }
}))

export default SaveButton
